import React, {useState} from "react";
import {CustomerFluidSubPageLayout} from "../../layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {MerchantCashOnDeliveryPage} from "../../cashOnDelivery/merchant/MerchantCashOnDeliveryPage";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";
import {useCodPaymentMethodSelection} from "hooks/useCodPaymentMethodSelection";
import styled from "styled-components";
import {Empty, Modal} from "antd";
import {CodPaymentMethodSelectionForm} from "components/layouts/customerLayout/components/codPaymentMethodSelectionForm/CodPaymentMethodSelectionForm";
import {CaretRightOutlined} from "@ant-design/icons";
import {CustomButton} from "components/_defaultComponents/CustomButton/CustomButton";
import {ContractDetails} from "components/layouts/customerLayout/components/customerAccountingDetailInfo/CustomerAccountingDetailInfo.styles";

const EmptyWrapper = styled.div`
    background-color: white;
    border-radius: 8px;
    padding: 40px 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

const InfoItem = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
`;

const CustomerCashOnDeliveryPage = ({isBackoffice = false}) => {
    const [recall, setRecall] = useState(false);
    const [open, setOpen] = useState(false);
    const {
        subCompaniesResults,
        subCompaniesResultsLoading,
        canCodPaymentMethodSelectionSubcompanies,
        canShowCodPaymentMethodSelection,
        alreadyHasCoDPaymentContractSubcompanies,
        generateCoDPaymentContract,
        getCoDPaymentContract,
        contractLoading
    } = useCodPaymentMethodSelection({
        initialCall: true,
        initialData: [],
        dependencies: [recall],
        isBackoffice: isBackoffice
    });

    return (
        <CustomerFluidSubPageLayout pageTitle="Kapıda Ödeme">
            <CustomerMenuHeader
                canShowCodPaymentMethodSelection={canShowCodPaymentMethodSelection}
            />
            {subCompaniesResultsLoading ? (
                <div style={{padding: "40px", textAlign: "center"}}>Yükleniyor...</div>
            ) : canShowCodPaymentMethodSelection ? (
                <EmptyWrapper>
                    <Empty
                        description={
                            <span>
                                Siparişlerinizde kapıda ödeme alabilmemiz için ilgili{" "}
                                <strong>sözleşmeyi</strong> onaylayınız.
                            </span>
                        }
                    />
                    <InfoItem>
                        <ContractDetails style={{marginLeft: "auto", marginTop: "auto"}}>
                            <CustomButton
                                onClick={() => setOpen(true)}
                                className="all-contracts-btn"
                                style={{marginRight: "0px"}}
                            >
                                Kapıda Ödeme Sözleşmesi Oluştur
                                <CaretRightOutlined />
                            </CustomButton>
                        </ContractDetails>
                    </InfoItem>
                </EmptyWrapper>
            ) : (
                <MerchantCashOnDeliveryPage />
            )}
            <Modal
                visible={open}
                onCancel={() => setOpen(false)}
                footer={null}
                width={1000}
                centered
            >
                <CodPaymentMethodSelectionForm
                    recallState={recall}
                    recallFn={() => {
                        setRecall(!recall);
                        setOpen(false);
                    }}
                    paymentMethodsSelectionEnabledSubCompanies={
                        canCodPaymentMethodSelectionSubcompanies || []
                    }
                />
            </Modal>
        </CustomerFluidSubPageLayout>
    );
};

export default CustomerCashOnDeliveryPage;
